import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/demoday')({
  beforeLoad: ({ context }) => {
    // Already-authed users have nothing to do here — send them home.
    if (context.auth.isAuthenticated && !context.auth.isLoading) {
      throw redirect({ to: '/' })
    }
  },
  component: DemoDayLayout,
})

/**
 * Full-bleed brand-styled shell for the demo-day signup flow.
 *
 * Lives outside the _authed layout so the page is reachable without a session.
 * On a successful POST /app/demoday/signup the API sets the auth cookie and
 * the user is escorted into the main app.
 */
function DemoDayLayout() {
  // Outer div is the scroll container. The app root applies `overflow: hidden`
  // to html/body and wraps every route in a `h-screen overflow-hidden` div, so
  // body-level scroll can't reach the submit button when the form gets tall
  // (e.g. several teammate rows on a short viewport). The inner shell carries
  // the gradient + orbs and grows with content via `min-h-full` so the brand
  // background covers the full scrollable height, not just the initial viewport.
  return (
    <div className="h-svh w-full overflow-y-auto">
      <div className="relative min-h-full w-full bg-linear-to-br from-slate-50 via-white to-blue-50/40">
        <div className="pointer-events-none absolute inset-0 overflow-hidden">
          <div
            aria-hidden
            className="absolute -left-32 -top-32 h-96 w-96 rounded-full bg-blue-200/30 blur-3xl"
          />
          <div
            aria-hidden
            className="absolute -bottom-32 -right-32 h-96 w-96 rounded-full bg-indigo-200/30 blur-3xl"
          />
        </div>

        <header className="relative z-10 flex justify-center px-6 pt-10 md:justify-start md:px-12">
          <img
            src={`${import.meta.env.BASE_URL}assets/logo_with_text_side.svg`}
            alt="Supplyco Logo"
            className="h-10 w-auto object-contain md:h-12"
          />
        </header>

        <main className="relative z-10 flex min-h-[calc(100svh-7rem)] items-start justify-center px-4 py-8 md:px-12 md:py-12">
          <div className="w-full max-w-xl">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}
